import React from "react";
import { useCallback } from "react";
import { get } from 'lodash';
import { clone } from "../../../shared/utility";

import GridContainer from "../../../components/Grid/GridContainer";
import GridItem from "../../../components/Grid/GridItem";
import Button from "../../../components/CustomButtons/Button";

import { checkOutsideBrokerOrReferralFirmFields } from "../RSheetsLogic";
import Brokers from "../CommonCustomElements/Brokers";
import LessEntry from "../CommonCustomElements/LessEntry";
import LessContacts from "../CommonCustomElements/LessContacts";

export const LESSEE_OUTSIDE_BROKER_FIELDS = [
	"outside_broker_company_name",
    "outside_broker_name",
    "outside_broker_lastname",
    "outside_broker_address1",
    "outside_broker_address2",
    "outside_broker_city",
    "outside_broker_state",
    "outside_broker_zip",
    "outside_broker_contact",
    "outside_broker_fax",
    "outside_broker_main_phone",
    "outside_broker_email",
    "outside_broker_taxid",
    "outside_broker_w9",
    "outside_broker_w9_upload",
    "outside_broker_commission",
];

export const LESSEE_OUTSIDE_BROKE_NON_REQUIRED_FIELDS = ["outside_broker_fax","outside_broker_taxid"];

const Step4 = (props) => {
    const { data, setData, section } = props;

    return (
        <div>
            
            <GridContainer>
                {(section === 'lessees' || !section) && <GridItem xs={12} sm={12} md={12}>
                    <LessEntry 
                        data={data}
                        setData={setData}
                        rsType="Lease Assignment"
                        fieldType="lessees"
                        fieldName="Assignee"
                    />
                    {data.lessees.length === 0 && <div className="red-text" style={{margin:20}}>Assignee Required</div>}
                </GridItem>}
                {(section === 'lessee_contacts' || !section) && <GridItem xs={12} sm={12} md={12}>
                    <hr />
                    <LessContacts 
                        data={data}
                        setData={setData}
                        fieldType="lessee_contacts"
                        fieldName="Assignee Contact"
                    />
                    <hr />
                </GridItem>}
                {(section === 'lessee_brokers' || !section) && <GridItem xs={12} sm={12} md={12}>
                    <Brokers 
                        data={data}
                        setData={setData}
                        outside_brokers_field_name="outside_broker" 
                        outside_brokers_field_label="ASSIGNEE"
                    />
                </GridItem>}
                
            </GridContainer>
        </div>
    );
};

export default Step4;
